import { Button, Descriptions, Divider, Popconfirm } from "antd";
import React from "react";
import {
  Basement as TypeBasement,
  Crane as TypeCrane,
  Crane1 as TypeCrane1,
  Crane1ItemCodes,
  Electrify as TypeElectrify,
  ITEM_BASEMENT,
  ITEM_CRANE,
  ITEM_CRANE1,
  ITEM_ELECTRIFY,
  ITEM_OIL,
  ITEM_SR,
  ITEM_DR,
  ITEM_TYRE,
  ITEM_VT,
  ITEM_WHEEl,
  Oil as TypeOil,
  Trouble as TypeTrouble,
  OneOfItems,
  ServeModes,
  SR as TypeSR,
  SrDifficulties,
  Tyre as TypeTyre,
  VT as TypeVt,
  Wheel as TypeWheel,
  ITEM_OTHER,
  Location,
  OtherFee as TypeOtherFee,
} from "../../../constants/serve";
import LocationViewer from "./common/location-viewer"

type DeleteFunc = {
  onDelete?: (type: number, item: OneOfItems) => void;
};

type locations = {locations : Location[] | null}

const VT: React.FC<{ vts: TypeVt[] | null | undefined } & DeleteFunc & locations> = ({
  vts,
  onDelete,
  locations
}) => {
  if (vts == null) {
    return <></>;
  }

  const views = vts.map((vt) => (
    <Descriptions
      key={vt.id + "_" + vt.mode}
      title={`车辆运输 - ${ServeModes[vt.mode]}`}
      column={4}
      extra={
        [<LocationViewer key={"loc-" + vt.sid} distance={vt.distance}  starting={locations?.filter((item=>item.id===vt.starting))[0]}  destination={locations?.filter((item=>item.id===vt.destination))[0]} sid={vt.sid} itemId={vt.id} item={ITEM_VT} title="查看导航"></LocationViewer>,
        onDelete ? (
          <Popconfirm
            key={`delet-btn-${vt.id}`}
            title="确认删车辆运输？"
            onConfirm={() => onDelete(ITEM_VT, vt)}
          >
            <Button danger type="primary" className="margin-left-16px">
              删除
            </Button>
          </Popconfirm>
        ) : null]

      }
    >
      <Descriptions.Item label="起步价">
        ¥{vt.startingFee / 100} 元
      </Descriptions.Item>
      <Descriptions.Item label="距离">
        {Math.ceil(vt.distance / 1000)} 公里
      </Descriptions.Item>
      <Descriptions.Item label="总费用">
        ¥{vt.totalFee / 100} 元
      </Descriptions.Item>
    </Descriptions>
  ));

  return (
    <>
      {views}
      <Divider />
    </>
  );
};

const Crane1: React.FC<
  { crane1: TypeCrane1 | null | undefined } & DeleteFunc & locations
> = ({ crane1, onDelete, locations }) => {
  if (crane1 == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title="吊车 - 事故救援"
        column={4}
        extra={
          [<LocationViewer key={crane1.id + '' + ITEM_CRANE1} distance={crane1.distance} sid={crane1.sid} itemId={crane1.id} item={ITEM_CRANE1} title="查看导航" starting={locations?.filter((item=>item.id===crane1.starting))[0]}  destination={locations?.filter((item=>item.id===crane1.destination))[0]}></LocationViewer>,
          onDelete ? (
            <Popconfirm
              key="loca-byn"
              title="确认删除吊车？"
              onConfirm={() => onDelete(ITEM_CRANE1, crane1)}
            >
              <Button danger type="primary" className="margin-left-16px">
                删除
              </Button>
            </Popconfirm>
          ) : null]
        }
      >
        <Descriptions.Item label="距离">
          {Math.ceil(crane1.distance / 1000)} 公里
        </Descriptions.Item>
        <Descriptions.Item label="吨位">
          {Crane1ItemCodes[crane1.itemCode]}
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{crane1.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const Crane: React.FC<{ crane: TypeCrane | null | undefined } & DeleteFunc &locations> = ({
  crane,
  onDelete,
  locations
}) => {
  if (crane == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title="随车吊 - 事故救援"
        column={4}
        extra={
          [<LocationViewer key={crane.id + '' + ITEM_CRANE1} distance={crane.distance}  sid={crane.sid} itemId={crane.id} item={ITEM_CRANE} title="查看导航" starting={locations?.filter((item=>item.id===crane.starting))[0]}  destination={locations?.filter((item=>item.id===crane.destination))[0]}></LocationViewer>,
          onDelete ? (
            <Popconfirm
              key="loca-byn"
              title="确认删除？"
              onConfirm={() => onDelete(ITEM_CRANE, crane)}
            >
              <Button danger type="primary" className="margin-left-16px">
                删除
              </Button>
            </Popconfirm>
          ) : null]
        }
      >
        <Descriptions.Item label="距离">
          {Math.ceil(crane.distance / 1000)} 公里
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{crane.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const Basement: React.FC<
  { basement: TypeBasement | null | undefined } & DeleteFunc
> = ({ basement, onDelete }) => {
  if (basement == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title="地库救援 - 事故救援"
        column={4}
        extra={
          onDelete ? (
            <Popconfirm
              title="确认删除地库救援？"
              onConfirm={() => onDelete(ITEM_BASEMENT, basement)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null
        }
      >
        <Descriptions.Item label="总费用">
          ¥{basement.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const SR: React.FC<{ sr: TypeSR | null | undefined } & DeleteFunc> = ({
  sr,
  onDelete,
}) => {
  if (sr == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title="现场救援 - 事故救援"
        column={4}
        extra={
          onDelete ? (
            <Popconfirm
              title="确认删除现场救援？"
              onConfirm={() => onDelete(ITEM_SR, sr)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null
        }
      >
        <Descriptions.Item label="救援难度">
          {SrDifficulties[sr.difficulty]}
        </Descriptions.Item>
        <Descriptions.Item label="难度费用">
          ¥{sr.baseFee / 100} 元
        </Descriptions.Item>
        <Descriptions.Item label="人工">{sr.labor}人</Descriptions.Item>
        <Descriptions.Item label="时长">{sr.hours}小时</Descriptions.Item>
        <Descriptions.Item label="施救距离">{sr.distance}米</Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{sr.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const Wheel: React.FC<{ wheel: TypeWheel | null | undefined } & DeleteFunc> = ({
  wheel,
  onDelete,
}) => {
  if (wheel == null) {
    return <></>;
  }
  return (
    <>
      <Descriptions
        title="辅助轮 - 事故救援"
        column={4}
        extra={
          onDelete ? (
            <Popconfirm
              title="确认删除辅助轮？"
              onConfirm={() => onDelete(ITEM_WHEEl, wheel)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null
        }
      >
        <Descriptions.Item label="个数">{wheel.count}</Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{wheel.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const Oil: React.FC<{ oil: TypeOil | null | undefined } & DeleteFunc & locations> = ({
  oil,
  onDelete,
  locations
}) => {
  if (oil == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title="送油 - 非事故救援"
        column={4}
        extra={
          [<LocationViewer key={oil.id + '' + ITEM_CRANE1} distance={oil.distance}  sid={oil.sid} itemId={oil.id} item={ITEM_OIL} title="查看导航" starting={locations?.filter((item=>item.id===oil.starting))[0]}  destination={locations?.filter((item=>item.id===oil.destination))[0]}></LocationViewer>,
          onDelete ? (
            <Popconfirm
              className="margin-left-16px"
              key="loca-byn"
              title="确认删除送油服务？"
              onConfirm={() => onDelete(ITEM_OIL, oil)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null]
        }
      >
        <Descriptions.Item label="距离">
          {Math.ceil(oil.distance / 1000)} 公里
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{oil.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const Electrify: React.FC<
  { electrify: TypeElectrify | null | undefined } & DeleteFunc & locations
> = ({ electrify, onDelete,locations }) => {
  if (electrify == null) {
    return <></>;
  }
  return (
    <>
      <Descriptions
        title="搭电 - 非事故救援"
        column={4}
        extra={
          [<LocationViewer key={electrify.id + '' + ITEM_CRANE1} distance={electrify.distance}  sid={electrify.sid} itemId={electrify.id} item={ITEM_ELECTRIFY} title="查看导航" starting={locations?.filter((item=>item.id===electrify.starting))[0]}  destination={locations?.filter((item=>item.id===electrify.destination))[0]}></LocationViewer>,
          onDelete ? (
            <Popconfirm
              key="loca-byn"
              className="margin-left-16px"
              title="确认删除搭电服务？"
              onConfirm={() => onDelete(ITEM_ELECTRIFY, electrify)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null]
        }
      >
        <Descriptions.Item label="距离">
          {Math.ceil(electrify.distance / 1000)} 公里
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{electrify.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

const Tyre: React.FC<{ tyre: TypeTyre | null | undefined } & DeleteFunc & locations> = ({
  tyre,
  onDelete,
  locations
}) => {
  if (tyre == null) {
    return <></>;
  }
  return (
    <>
      <Descriptions
        title="换胎 - 非事故救援"
        column={4}
        extra={
          [<LocationViewer key="location-1" sid={tyre.sid} distance={tyre.distance}  itemId={tyre.id} item={ITEM_TYRE} title="查看导航" starting={locations?.filter((item=>item.id===tyre.starting))[0]}  destination={locations?.filter((item=>item.id===tyre.destination))[0]}></LocationViewer>,
          onDelete ? (
            <Popconfirm
              className="margin-left-16px"
              key="loca-byn"
              title="确认删除换胎服务？"
              onConfirm={() => onDelete(ITEM_TYRE, tyre)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null]
        }
      >
        <Descriptions.Item label="距离">
          {Math.ceil(tyre.distance / 1000)} 公里
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{tyre.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};


// 困境救援
const Trouble: React.FC<{ trouble: TypeTrouble | null | undefined } & DeleteFunc & locations> = ({
  trouble,
  onDelete,
  locations
}) => {
  if (trouble == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title="困境救援 - 非事故救援"
        column={4}
        extra={
          [<LocationViewer key="location-1" sid={trouble.sid} distance={trouble.distance}  itemId={trouble.id} item={ITEM_DR} title="查看导航" starting={locations?.filter((item=>item.id===trouble.starting))[0]}  destination={locations?.filter((item=>item.id===trouble.destination))[0]}></LocationViewer>,
          onDelete ? (
            <Popconfirm
              key="loca-byn"
              className="margin-left-16px"
              title="确认删除困境救援服务？"
              onConfirm={() => onDelete(ITEM_DR, trouble)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null]
        }
      >
        <Descriptions.Item label="距离">
          {Math.ceil(trouble.distance / 1000)} 公里
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{trouble.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

// 其他费用
const OtherFee: React.FC<{ otherFee: TypeOtherFee | null | undefined } & DeleteFunc> = ({
  otherFee,
  onDelete,
}) => {
  if (otherFee == null) {
    return <></>;
  }
  return (
    <>
      <Descriptions
        title="其他费用"
        column={4}
        extra={
          onDelete ? (
            <Popconfirm
              title="确认删除辅助轮？"
              onConfirm={() => onDelete(ITEM_OTHER, otherFee)}
            >
              <Button danger type="primary">
                删除
              </Button>
            </Popconfirm>
          ) : null
        }
      >
        <Descriptions.Item label="说明">{otherFee.remark}</Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{otherFee.totalFee / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

export { VT, Crane, Crane1, Basement, SR, Wheel, Oil, Electrify, Tyre, Trouble, OtherFee };
